import { useEffect, useState } from "react";
import { Plug } from "lucide-react";
import { toast } from "sonner";
import api from "../../api";
import { PageTitle, Badge } from "./AdminLayout";

const TONE = { connected: "green", idle: "grey", not_configured: "amber", error: "red" };

export default function IntegrationsAdmin() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/extras/integrations").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = async (key, status, detail) => {
    try {
      const res = await api.put("/admin/extras/integrations", { key, status, detail });
      setItems(res.data);
      toast.success("Integration updated");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div data-testid="admin-integrations">
      <PageTitle title="Integrations" sub="Third-party services wired into GrooveMusic." />
      <div className="grid md:grid-cols-2 gap-4 max-w-4xl" data-testid="integrations-list">
        {items.map((i) => (
          <div key={i.key} className="rounded-lg border border-white/5 bg-panel p-6" data-testid={`integration-${i.key}`}>
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-heading font-bold text-white flex items-center gap-2.5"><Plug size={15} className="text-blurple" /> {i.name}</h3>
              <Badge tone={TONE[i.status] || "grey"}>{i.status.replace("_", " ")}</Badge>
            </div>
            <p className="text-sm text-white/50 mb-4">{i.detail}</p>
            <div className="flex gap-2">
              {["connected", "idle", "error"].map((s) => (
                <button key={s} onClick={() => update(i.key, s, i.detail)} data-testid={`integration-${i.key}-${s}`}
                  className={`text-xs font-semibold rounded-full px-3.5 py-1.5 border transition-colors duration-150 ${i.status === s ? "border-blurple/50 text-white bg-blurple/15" : "border-white/15 text-white/50 hover:text-white"}`}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
